module.exports = __webpack_public_path__ + "img/04.5fe1ffd1.png";